import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { ExpenseApplyParam } from '../../models/gen/expenseApplyParam';
import { ExpenseApplySingleSearchParam } from '../../models/gen/expenseApplySingleSearchParam';
import { ExpenseApplySingleSearchResult } from '../../models/gen/expenseApplySingleSearchResult';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const EXPENSE_APPLY_CONTEXT_NAMES = {
  POST_EXPENSE_APPLY_APPLY: 'applyExpenseApply',
  POST_EXPENSE_APPLY_SINGLE_SEARCH: 'searchSingleExpenseApply',
} as const;

const apis = apiGenerator();

/**
 * POST `/expense-apply/apply`
 *
 * @param param -
 * @returns
 */
export const usePostExpenseApplyApply = () =>
  useGenericMutation(async (param: ExpenseApplyParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/expense-apply/apply`, {
      ...queryOptions,
      data: param,
    })
  );

/**
 * POST `/expense-apply/single-search 2回`
 *
 * @param param -
 * @returns
 */
export const usePostExpenseApplySearch = () =>
  useGenericMutation(
    async (
      params: [ExpenseApplySingleSearchParam, ExpenseApplySingleSearchParam]
    ) =>
      Promise.all(
        params.map((param) =>
          apis.post<
            ExpenseApplySingleSearchParam,
            ExpenseApplySingleSearchResult
          >(`${env.BASE_API_ENDPOINT}/expense-apply/single-search`, {
            ...queryOptions,
            data: param,
          })
        )
      )
  );

/**
 * POST `/expense-apply/single-search`
 *
 * @param param -
 * @returns
 */
export const usePostExpenseApplySingleSearch = () =>
  useGenericMutation(async (param: ExpenseApplySingleSearchParam) =>
    apis.post<ExpenseApplySingleSearchParam, ExpenseApplySingleSearchResult>(
      `${env.BASE_API_ENDPOINT}/expense-apply/single-search`,
      { ...queryOptions, data: param }
    )
  );
